import React from "react";

import classnames from "classnames";
import isString from "lodash/isString";

import { Link, Text } from "components/ui/source";

import { IconComponent } from "icons/react/Icon";

import styles from "./IconText.module.scss";

interface TextListProps {
  className: string;
  texts?: string[];
  textProps?: object;
}

function TextList({ className, texts, textProps }: TextListProps) {
  const listElements = texts.map(text => (
    <li key={text}>
      <Text types={["body1"]} {...textProps}>
        {textTolink(text)}
      </Text>
    </li>
  ));

  return <ul className={className}>{listElements}</ul>;
}

export function textTolink(text: string) {
  if (!text) return text;

  const URL_REGEX =
    /https?(\.|:)\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

  return (
    <>
      {text.split(" ").map(word => {
        const isUrl = URL_REGEX.test(word);
        if (isUrl) {
          const url = new URL(word);
          const isGoogleMapUrl = word.includes("google.com/maps");
          return (
            <>
              <Link
                href={word}
                text={url?.host || word.substring(0, 16)}
                textElement="span"
                textTypes={["body1"]}
                translateKey={
                  isGoogleMapUrl && "listing:neighborhood.openMapCta"
                }
                inline
                newTab
                underline
              />
              <br />
            </>
          );
        } else return word + " ";
      })}
    </>
  );
}

export interface IconTextProps {
  children?: React.ReactNode;
  className?: string;
  Icon: IconComponent;
  title: string;
  titleTextProps?: object;
  description?: string | string[];
  descriptionTextProps?: object;
}

export default function IconText({
  children,
  className,
  Icon,
  title,
  titleTextProps,
  description,
  descriptionTextProps,
}: IconTextProps) {
  if (!title) return null;
  if (Array.isArray(description) && description.length == 0) return null;

  // Check if description is an i18n text key
  const isTranslateKey =
    isString(description) && /^[a-z0-9.:]+$/i.test(description as string);

  return (
    <div className={classnames(styles.container, className)}>
      <Icon className={styles.icon} size="xl" color="deep-green" />
      <div>
        <Text
          className={styles.title}
          types={["body1", "medium", "pre_wrap"]}
          translateKey={title}
          {...titleTextProps}
        />

        {Array.isArray(description) ? (
          <TextList
            className={styles.description_list}
            texts={description}
            textProps={descriptionTextProps}
          />
        ) : (
          <Text
            className={styles.description}
            types={["body1"]}
            {...descriptionTextProps}
            {...(isTranslateKey ? { translateKey: description } : {})}
          >
            {!isTranslateKey && textTolink(description)}
          </Text>
        )}
        {children}
      </div>
    </div>
  );
}
